import { AssistantContent, MarkdownContent } from "../../Chat";

type FeedbackSectionProps = {
  children: string;
  tone?: "neutral" | "warning";
  isCode?: boolean;
  renderMarkdown?: boolean;
  renderAssistantContent?: boolean;
};

export function FeedbackSection({
  children,
  tone = "neutral",
  isCode = false,
  renderMarkdown = false,
  renderAssistantContent = false,
}: FeedbackSectionProps) {
  const contentClass =
    tone === "warning"
      ? "bg-amber-50 text-gray-800 ring-1 ring-amber-100"
      : "bg-gray-50 text-gray-800 ring-1 ring-gray-100";

  return (
    <>
      {isCode ? (
        <pre
          className={`overflow-x-auto whitespace-pre-wrap break-words rounded-lg px-3 py-2 text-xs ${contentClass}`}
        >
          {children}
        </pre>
      ) : renderAssistantContent ? (
        <div className={`rounded-lg px-3 py-2 text-sm ${contentClass}`}>
          <AssistantContent content={children} actionsMode="hidden" />
        </div>
      ) : renderMarkdown ? (
        <div className={`rounded-lg px-3 py-2 text-sm ${contentClass}`}>
          <MarkdownContent content={children} />
        </div>
      ) : (
        <p
          className={`whitespace-pre-wrap rounded-lg px-3 py-2 text-sm ${contentClass}`}
        >
          {children}
        </p>
      )}
    </>
  );
}
